import { render } from "./ViewPage.vue?vue&type=template&id=b49bfeb8&ts=true"
import script from "./ViewPage.vue?vue&type=script&lang=ts"
export * from "./ViewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__